
import React from 'react';
import { AgentProfile, Language } from '../../types';

interface RobotListProps {
  language: Language;
  activeAgent: AgentProfile;
  agents: AgentProfile[];
  agentLimit: number;
  activeTab: 'agents' | 'visual' | 'options';
  onAddAgent: () => void;
  onSetActiveAgent: (id: string) => void;
  onSetActiveTab: (tab: 'agents' | 'visual' | 'options') => void;
  onDuplicateAgent: (agent: AgentProfile) => void;
  onResetAgent: (id: string) => void;
  onDeleteAgent: (id: string) => void;
  isRtl: boolean;
}

const RobotList: React.FC<RobotListProps> = ({ 
  language, activeAgent, agents, agentLimit, activeTab, 
  onAddAgent, onSetActiveAgent, onSetActiveTab, 
  onDuplicateAgent, onResetAgent, onDeleteAgent, isRtl 
}) => {
  return (
    <aside className={`lg:w-80 w-full bg-white dark:bg-[#0a0a0c] border-b lg:border-b-0 lg:border-r border-slate-200 dark:border-white/5 flex flex-col z-40 transition-transform duration-300 absolute lg:static inset-0 lg:inset-auto ${activeTab === 'agents' ? 'translate-x-0' : (isRtl ? 'translate-x-full lg:translate-x-0' : '-translate-x-full lg:translate-x-0')}`}>
       <div className="p-4 lg:p-6 border-b border-slate-100 dark:border-white/5 flex items-center justify-between bg-slate-50/50 dark:bg-white/[0.01]">
          <h3 className="text-[10px] lg:text-xs font-black uppercase text-slate-400 dark:text-slate-500 tracking-widest">{isRtl ? 'سجل الوكلاء' : 'Agent Registry'}</h3>
          <div className="flex items-center gap-3">
             <span className="text-[10px] font-bold text-slate-400">{agents.length} / {agentLimit}</span>
             <button onClick={onAddAgent} className="w-7 h-7 lg:w-9 lg:h-9 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg lg:rounded-xl flex items-center justify-center transition-all shadow-lg shadow-emerald-500/20 active:scale-95"><i className="fas fa-plus text-xs lg:text-sm"></i></button>
          </div>
       </div>
       <div className="flex-1 overflow-y-auto custom-scrollbar p-3 lg:p-4 space-y-3">
          {agents.map(agent => (
             <div key={agent.id} onClick={() => { onSetActiveAgent(agent.id); onSetActiveTab('visual'); }} className={`group relative p-3 lg:p-4 rounded-2xl border transition-all cursor-pointer overflow-hidden ${activeAgent.id === agent.id ? 'bg-emerald-50 dark:bg-emerald-500/5 border-emerald-500/30 shadow-md' : 'bg-white dark:bg-white/[0.02] border-slate-100 dark:border-white/5 hover:border-slate-300 dark:hover:border-white/10'}`}>
                <div className="flex items-start gap-3 lg:gap-4">
                   <div className={`w-10 h-10 lg:w-12 lg:h-12 rounded-xl flex items-center justify-center text-lg lg:text-xl shadow-sm ${activeAgent.id === agent.id ? 'bg-emerald-500 text-white' : 'bg-slate-100 dark:bg-white/10 text-slate-400'}`}><i className={`fas ${agent.avatar}`}></i></div>
                   <div className="flex-1 min-w-0"><h4 className={`text-xs lg:text-sm font-black truncate ${activeAgent.id === agent.id ? 'text-slate-800 dark:text-emerald-400' : 'text-slate-600 dark:text-slate-300'}`}>{agent.name}</h4><p className="text-[10px] lg:text-xs text-slate-400 truncate mt-0.5">{agent.role}</p></div>
                </div>
                <div className={`mt-3 lg:mt-4 pt-3 lg:pt-4 border-t border-slate-100 dark:border-white/5 flex justify-between opacity-50 group-hover:opacity-100 transition-opacity ${activeAgent.id === agent.id ? 'opacity-100' : ''}`}>
                   <div className="flex gap-1">
                      <button onClick={(e) => { e.stopPropagation(); onDuplicateAgent(agent); }} className="w-6 h-6 rounded-md text-slate-400 hover:text-emerald-500 transition-colors"><i className="fas fa-copy text-[10px]"></i></button>
                      <button onClick={(e) => { e.stopPropagation(); onResetAgent(agent.id); }} className="w-6 h-6 rounded-md text-slate-400 hover:text-amber-500 transition-colors"><i className="fas fa-rotate-left text-[10px]"></i></button>
                   </div>
                   <button onClick={(e) => { e.stopPropagation(); onDeleteAgent(agent.id); }} className="w-6 h-6 rounded-md text-slate-300 hover:text-rose-500 transition-colors"><i className="fas fa-trash text-[10px]"></i></button>
                </div>
             </div>
          ))}
       </div>
    </aside>
  );
};
export default RobotList;
